(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CommentDialogController', CommentDialogController);

    CommentDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','entity','Comment','Contract','Shipment','Invoice','Lot',
                            'shipmentEntity','contractEntity','lotEntity','invoiceEntity','requiredDocumentEntity','controllerEntity','controllerPaymentEntity'];

    function CommentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Comment, Contract, Shipment, Invoice, Lot,
                            shipmentEntity, contractEntity, lotEntity, invoiceEntity, requiredDocumentEntity, controllerEntity, controllerPaymentEntity ) {
        var vm = this;

        vm.comment = entity;
        vm.comment.contract = contractEntity;
        vm.comment.shipment = shipmentEntity;
        vm.comment.lot = lotEntity;
        vm.comment.invoice = invoiceEntity;
        vm.comment.requiredDocument = requiredDocumentEntity;
        vm.comment.controller = controllerEntity;
        vm.comment.controllerPayment = controllerPaymentEntity;
        vm.modComment = angular.copy( entity );
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        // vm.contracts = Contract.query();
        // vm.shipments = Shipment.query();
        // vm.invoices = Invoice.query();
        // vm.lots = Lot.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.comment = vm.modComment;
            vm.isSaving = true;
            if (vm.comment.id !== null) {
                Comment.update(vm.comment, onSaveSuccess, onSaveError);
            } else {
                Comment.save(vm.comment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:commentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
